import { useTimelineCursorTime } from 'app/agriculture/AgTimeline/context/TimelineContext';
import { formatISO, startOfHour } from 'date-fns';

export function useGenericSparkChartIndex() {
    const cursorTime = useTimelineCursorTime();
    const currentHour = cursorTime ? startOfHour(cursorTime) : startOfHour(new Date());
    return formatISO(currentHour);
}
